import { FC } from "react";
import Lottie from "react-lottie";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import useViewport from "../../../hooks/useViewport/useViewport";
import animationData from "./lotties/progress-loader.json";
import { ProgressLoaderProps } from "./ProgressLoader.types";
import { StyledProgressLoader } from "./ProgressLoader.styles";
import { ViewportResult } from "../../../hooks/useViewport/useViewport.types";

const ProgressLoader: FC<ProgressLoaderProps> = ({ className, ...props }) => {
	const block = new BemIt("ProgressLoader");

	const vp: ViewportResult = useViewport();

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: "xMidYMid slice",
		},
	};

	return (
		<StyledProgressLoader
			className={addClass(className).after(block)}
			viewport={vp}
			{...props}
		>
			<Lottie
				options={defaultOptions}
				height="100%"
				width="100%"
				isClickToPauseDisabled={true}
				ariaLabel="progress loader"
			/>
		</StyledProgressLoader>
	);
};

export default ProgressLoader;
